import { __awaiter } from "tslib";
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));
export const callWithRetry = (fn, maxTries = 7, currentTry = 1) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield fn();
    }
    catch (e) {
        if (currentTry >= maxTries) {
            throw e;
        }
        yield wait(Math.pow(2, currentTry) * 10);
        return callWithRetry(fn, maxTries, currentTry + 1);
    }
});
export const callPromiseWithRetry = (fn, maxTries = 7, currentTry = 1) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield fn;
    }
    catch (e) {
        if (currentTry >= maxTries) {
            throw e;
        }
        yield wait(Math.pow(2, currentTry) * 10);
        return callPromiseWithRetry(fn, maxTries, currentTry + 1);
    }
});
